import { render, staticRenderFns } from "./NewFolderDialog.vue?vue&type=template&id=01b199a7&scoped=true&"
import script from "./NewFolderDialog.vue?vue&type=script&lang=js&"
export * from "./NewFolderDialog.vue?vue&type=script&lang=js&"
import style0 from "./NewFolderDialog.vue?vue&type=style&index=0&id=01b199a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b199a7",
  null
  
)

export default component.exports